<script setup lang="ts">
import EmployeeProfile from '@/components/Profile/EmployeeProfile.vue';
import ManagerProfile from '@/components/Profile/ManagerProfile.vue';
import { useExternalUrl } from '@/composables/useExternalUrl';
import { usePlatform } from '@/composables/usePlatform';
import { useVersionCheck } from '@/composables/useVersionCheck';
import type { MessageSchema } from '@/i18n/index.js';
import { useAppStore } from '@/stores/appStore';
import { useEnvStore } from '@/stores/envStore';
import { useUserStore } from '@/stores/useUserStore';
import Button from 'primevue/button';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const { t, locale } = useI18n<{ message: MessageSchema }>({ useScope: 'global' });
const { navigateToExternalUrl } = useExternalUrl();
// const toast = useToast()
// const router = useRouter()

// const { logout, isFetching } = useAuth()
// const user = ref(useUserStore().user)
// const { fetchData } = useFetch()
// // const router = useRouter()
// const fileInput: Ref<HTMLInputElement | null> = ref(null);
// const restaurant: Ref<Restaurant | null> = ref(null);
// const attributes: Ref<AttributesList | null> = ref(null)
const userStore = useUserStore();

// watchEffect(async () => {
//   if (user.value?.restaurants[0].id && !restaurant.value) {
//     const { data: dbRestaurant, error: dbRestaurantError } = await fetchData(
//       useEnvStore().apiUrl + '/restaurants/' + user.value?.restaurants[0].id,
//       'GET'
//     )
//     if (dbRestaurantError) console.log(dbRestaurantError)
//     else restaurant.value = dbRestaurant

//     const { data: dbAttributes, error: dbAttributesError } = await fetchData(
//       useEnvStore().apiUrl + '/restaurants/attributes',
//       'GET'
//     )
//     if (dbAttributesError) console.log(dbAttributesError)
//     else attributes.value = dbAttributes
//   }
// })

// const userInfos = computed(() => {
//   if (user.value) {
//     return {
//       fullName: `${user.value.first_name} ${user.value.last_name}`,
//       restaurantName: user.value.restaurants[0].name,
//       restaurationType: user.value.restaurants[0].restauration_type,
//     }
//   }
//   return {
//     fullName: '',
//     restaurantName: '',
//     restaurationType: '',
//   }
// })

// async function uploadRestaurantLogo(event: any) {
//   const files = event.target.files
//   if (files.length > 0) {
//     const file: File = files[0]

//     // Taille maximale autorisée (en octets) - ici 2 Mo (2048 Ko)
//     const maxFileSize = 2 * 1024 * 1024

//     // Vérifier la taille de l'image avant de procéder à l'upload
//     if (file.size > maxFileSize) {
//       toast.add({
//         severity: 'error',
//         summary: t('common.error'),
//         detail: t('menuDishView.fileTooLarge', { maxSizeMB: '2' }),
//         life: 3000,
//       })
//       return // Empêcher l'upload si le fichier est trop gros
//     }

//     const formData = new FormData()
//     formData.append('logo', file)

//     try {
//       const { data, error } = await fetchData(
//         `${useEnvStore().apiUrl}/restaurants/${restaurant.value?.id}/logo`,
//         'POST',
//         formData
//       )

//       // Si une erreur est retournée, vérifiez et affichez un message spécifique ou générique
//       if (error) {
//         console.log(error)
//         const errorMessage =
//           error?.details?.errors?.logo?.[0] || t('menuDishView.addUserImageError')

//         toast.add({
//           severity: 'error',
//           summary: t('common.error'),
//           detail: errorMessage,
//           life: 3000,
//         })
//       } else if (data && restaurant.value) {
//         // Si l'opération est réussie, mettez à jour le logo du restaurant
//         restaurant.value.logo_url = data.logo_url
//         restaurant.value.logo = data.logo

//         // toast.add({
//         //   severity: 'success',
//         //   summary: t('common.success'),
//         //   detail: t('menuDishView.addUserImageSuccess'),
//         //   life: 3000,
//         // })
//         await userStore.refreshUser()
//       }
//     } catch (error) {
//       console.error('An unexpected error occurred:', error)
//       toast.add({
//         severity: 'error',
//         summary: t('common.error'),
//         detail: t('menuDishView.addUserImageError'),
//         life: 3000,
//       })
//     }
//   }
// }

// const links = [
//   {
//     name: t('profile.profile.profileTab.profileTabLabel'),
//     icon: markRaw(ButtonProfile),
//     url: '/profile/my-profile',
//   },
//   {
//     name: t('profile.profile.restaurantTab.restaurantTabLabel'),
//     icon: markRaw(DiningIcon),
//     url: '/profile/my-restaurant',
//   },
//   {
//     name: t('profile.profile.restaurantTab.other.mySuppliers'),
//     icon: markRaw(HotIcon),
//     url: '/profile/suppliers',
//   },
//   {
//     name: t('profile.profile.restaurantTab.other.orders'),
//     icon: markRaw(ButtonOrders),
//     url: '/profile/orders',
//   }
//   // {
//   //   name: t('profile.profile.restaurantTab.other.orders'),
//   //   icon: markRaw(ButtonOrders),
//   //   url: '/profile/orders',
//   // }
//   // {
//   //   name: t('profile.profile.restaurantTab.other.tooling'),
//   //   icon: markRaw(SupplierIcon),
//   //   url: '/profile/my-restaurant?showTooling=true',
//   // },
//   // {
//   //   name: 'Abonnement',
//   //   icon: markRaw(CreditCardIcon),
//   //   url: '/profile/subscription',
//   // },
//   // {
//   //   name: 'Mes commandes',
//   //   icon: markRaw(ShoppingCartIcon),
//   //   url: '/profile/orders',
//   // },
//   // {
//   //   name: 'Plats planifiés',
//   //   icon: markRaw(),
//   //   url: '/profile/favorites',
//   // },
//   // {
//   //   name: 'Mes filtres',
//   //   icon: markRaw(FiltersIcon),
//   //   url: '/profile/filters',
//   // },
//   // {
//   //   name: 'Mes statistiques',
//   //   icon: markRaw(StatisticsIcon),
//   //   url: '/profile/statistics',
//   // },
//   // {
//   //   name: 'Mon équipe',
//   //   icon: markRaw(TeamIcon),
//   //   url: '/profile/team',
//   // },
//   // {
//   //   name: 'Historique',
//   //   icon: markRaw(HistoryIcon),
//   //   url: '/profile/generation-history',
//   // },MyProfileView
//   // {
//   //   name: 'Menus favoris',
//   //   icon: markRaw(HeartEmpty),
//   //   url: '/profile/favorites',
//   // },
//   // {
//   // name: 'Mes scans',
//   // icon: markRaw(ScanIcon),
//   // url: '/profile/my-scans',
//   // },
// ]

// // if (useEnvStore().environment !== 'production') {
// //   links.push({
// //     name: t('profile.profile.restaurantTab.other.orders'),
// //     icon: markRaw(ButtonOrders),
// //     url: '/profile/orders',
// //   })
// // }

///////////// PWA INSTALLATION  ////////////
// Function to check if the app is installed
const appStore = useAppStore();
const { isNative } = usePlatform();
const { updateAvailable, storeUrl } = useVersionCheck();

// Show PWA button only on web (not native) and if app is not installed
const showPWAButton = computed(() => !isNative.value && !appStore.isPwaInstalled);

// Show update button only on native platforms when update is available
const showUpdateButton = computed(() => isNative.value && updateAvailable.value);

async function installPWA() {
  appStore.showPrompt = true;
  // if (appStore.isIOS()) {
  // } else {
  //   await appStore.installPwa()
  // }
}

function handleUpdateApp() {
  if (storeUrl.value) {
    window.open(storeUrl.value, '_blank');
  }
}

const userGuideUrl = computed(() => {
  const supportedLocales = ['en', 'fr', 'de', 'it'];
  const language = supportedLocales.includes(locale.value) ? locale.value : 'en';
  return `https://gastronomia.ai/data/files/gastronomia_user_guide_${language}.pdf`;
});

const openUserGuide = async (event: Event) => {
  event.preventDefault();
  await navigateToExternalUrl(userGuideUrl.value);
};
</script>

<template>
  <main class="flex min-h-[70vh] flex-col">
    <ManagerProfile v-if="!userStore.isEmployee" />
    <EmployeeProfile v-else />

    <!-- <Button :label=" t('auth.logout')" class="w-full mt-8" @click="logout" :loading="isFetching" /> -->
    <div class="mx-auto mt-auto w-full py-4 text-center print:hidden">
      <div v-if="showPWAButton" class="my-4">
        <Button icon="pi pi-download" :label="t('pwa.installApp')" @click="installPWA" />
      </div>
      <div v-if="showUpdateButton" class="my-4">
        <Button icon="pi pi-refresh" :label="t('update.updateAvailable')" @click="handleUpdateApp" />
      </div>
      <p class="text-center">
        <span>{{ useEnvStore().appVersion }} - {{ useEnvStore().lastUpdate }}</span>
        <span v-if="useEnvStore().environment !== 'production'">
          | {{ useUserStore().user?.restaurants[0]?.total_credits }}
          crédits restants
        </span>
      </p>
      <div class="mt-6 text-center text-sm text-primary-500">
        <p>
          {{ t('profile.feedback.needHelp') }}
        </p>
        <p>
          <a href="mailto:support@gastronomia.ai" class="text-accent hover:underline">support@gastronomia.ai</a>
        </p>
        <p class="mt-2">
          {{ t('profile.feedback.haveQuestions') }}
          <a href="https://gastronomia.ai/faq" class="text-accent hover:underline" target="_blank">{{ t('profile.feedback.consultFAQ') }}</a>
        </p>
        <p class="mt-2">
          <Button link icon="pi pi-file-pdf" :pt="{ root: { class: 'mr-2 text-accent' } }" :label="t('profile.userGuide')" @click="openUserGuide" />
          <!-- <i class="pi pi-file-pdf text-sm"></i>
            {{ t('profile.userGuide') }}
          </Button> -->
        </p>
      </div>
    </div>
  </main>
</template>
